import {
  type UseWhitelistTableControllerProps,
  useWhitelistTableController,
} from "./WhitelistTable.controller";
import { WhitelistTablePresentation } from "./WhitelistTable.pres";

export const WhitelistTable = (props: UseWhitelistTableControllerProps) => {
  const controller = useWhitelistTableController(props);

  return <WhitelistTablePresentation {...controller} />;
};
